<template>
  <div
    class="header-box"
    :class="{
      'header-box-active': isColor,
    }"
  >
    <!-- 头部 -->
    <div
      class="header"
      :class="{
        'header-active': isColor,
      }"
    >
      <div class="header-auto wrap">
        <div class="header-auto-left">
          <span @click="handleRouterLogo" class="logo">
            <!-- <img src="@/assets/img/logo.png" alt="" /> -->
            森威汇拍
          </span>

          <ul class="nav">
            <li
              :class="item.id == activeId ? 'color-text_active' : 'color-text'"
              @click="handleChange(item)"
              v-for="item in tabData"
              :index="item.id"
              :key="item.id"
            >
              <span>
                {{ item.text }}
              </span>
            </li>
          </ul>
        </div>
        <!-- 登录 -->
        <div class="search-left" v-if="!userInfo" @click="handlerLogin">
          <img src="@/assets/img/login.png" alt="" />
          <h4>登录</h4>
        </div>
        <!-- 个人中心 -->
        <el-dropdown @command="handleCommand" v-else>
          <div class="search-left-block">
            <img src="@/assets/img/login.png" alt="" />
            <p class="user-text">
              您好，尊敬的会员 用户{{ userInfo && userInfo.phone }}
            </p>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">个人中心</el-dropdown-item>
            <el-dropdown-item command="1">退出账号</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // TODO: isColor: 是否在登录页和注册页面
  props: ["isColor"],
  data() {
    return {
      token: this.$store.state.User.token,
      userInfo: null,
      tabData: [
        { id: 1, text: "首页", pathUrl: "/home" },
        { id: 2, text: "拍卖会", pathUrl: "/auction" },
        { id: 3, text: "APP下载", pathUrl: "/appDownload" },
        { id: 4, text: "帮助中心", pathUrl: "/helpCenter" },
        { id: 5, text: "关于我们", pathUrl: "/aboutUs" },
      ],
      activeId: 1,
    };
  },
  methods: {
    handlerLogin() {
      // 每次点击都是登录
      this.$store.commit("HANLE_IS_LOGIN_OR_REGISTER", 1);
      // 弹窗弹起
      this.$store.commit("HANLE_VISIBLE_DIALOG", true);
    },
    // logo点击跳转
    handleRouterLogo() {
      this.$router.push("/");
    },
    // 跳转个人中心
    handleGoIndividualAccount() {
      this.$router.push("/individualAccount/rightMenu?type=1&name=个人资料");
    },
    // 每个tab点击
    handleChange(item) {
      this.$router.push(item.pathUrl);
      this.activeId = item.id;
    },
    // 退出登录
    handleCommand(command) {
      switch (command) {
        case "0":
          this.handleGoIndividualAccount();
          break;
        case "1":
          this.hanldeDropOut();
        default:
          break;
      }
    },
    // 退出
    async hanldeDropOut() {
      await this.$store.dispatch("userLogout");
      localStorage.removeItem("userInfo");
      this.$message.success("退出成功");
      this.userInfo = null;

      this.$nextTick(() => {
        // 打开弹窗
        this.$store.commit("HANLE_VISIBLE_DIALOG", true);
      });
    },
  },
  watch: {
    $route: {
      handler(newRoute) {
        // 根据当前路由设置activeId
        const matched = newRoute.matched;
        if (matched.length > 0) {
          const currentPath = matched[0].path;
          this.activeId =
            this.tabData.find((item) => item.pathUrl == currentPath)?.id || 1;
        }
      },
    },
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.token = this.$store.state.User.token;
    // this.activeId = this.$store.state.User.activeId;
  },
};
</script>

<style lang="less" scoped>
.header-box-active {
  height: 0 !important;
}
.header-box {
  height: 64px;
  .header-active {
    background: none !important;
    border-bottom: none !important;
  }
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    background-color: rgba(255, 255, 255, 0.9);

    border-bottom: 1px solid #f2f2f2;

    .header-auto {
      height: 4rem;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: rgba(255, 255, 255, 0);

      .header-auto-left {
        width: 650px;
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        cursor: pointer;
        .logo {
          width: 150px;
          height: 100%;
          font-size: 20px;
          font-weight: 600;
          padding: 4px 0;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .search-left {
        width: 75px;
        height: 20px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        border-left: 1px solid rgb(177, 177, 177);
        border-right: 1px solid rgb(177, 177, 177);
        cursor: pointer;

        img {
          width: 20px;
          height: 20px;
        }

        h4 {
          font-size: 18px;
        }
      }

      .search-left-block {
        padding: 0 20px;
        height: 30px;
        background-color: #eef1f6;
        border-radius: 30px;
        display: flex;
        justify-content: space-around;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          margin-right: 20px;
        }

        .user-text {
          text-align: center;
          width: 100%;
          display: block;
          font-size: 18px;
        }
      }
    }

    h1 {
      img {
        width: 130px;
      }
    }

    .nav {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;

      li {
        position: relative;
        cursor: pointer;
        text-decoration: none;
        width: 80px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;

        .color-text {
          color: #666;
          height: 100%;
        }
      }

      .color-text_active {
        color: #ff7a00;
        padding-bottom: 2px; /* 为横条留出空间 */
        &::after {
          content: "";
          display: block;
          position: absolute;
          left: 50%;
          bottom: 0px;
          transform: translateX(-50%);
          width: 100%; /* 横条宽度与包含块相同 */
          height: 2px; /* 横条高度，根据需要调整 */
          background-color: #ff7a00; /* 横条颜色，与文本颜色相同 */
        }
      }
    }
  }
}

// .header .header-auto .nav li;
</style>